import { useSelector } from "react-redux";

const Orders = () => {
  const OrgId = useSelector((state) => state.auth.org_id);
    return (
      <div className="">
          <iframe src={`https://iiplwork.retool.com/embedded/public/4e1991bb-cd78-4d49-882d-f46cb752ee93`}
          className="iframe-style"></iframe>
      </div>
  
    )
  };
  
  export default Orders;
  